import { Col, Divider, Row } from 'antd';
import CartApi from 'apis/CartApi';
import { CartBlue } from 'assets/svg';
import { useUser } from 'contexts/User';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

export default function CartIcon() {
  const { user } = useUser();
  const [cartData, setCartData] = useState<any>();
  const history = useHistory();
  const { isLoading: getCartOrderTVV, refetch } = useQuery(
    ['getCartOrderTVV'],
    () => {
      return CartApi.getCartOrderTVV(user?.plantId)
        .then((res) => {
          setCartData(res?.data || []);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  );

  useEffect(() => {
    refetch();
  }, [user?.plantId]);

  const renderContent = () => {
    return (cartData || [])?.map((item: any, index: any) => (
      <Row
        onClick={() => {
          history.push(`/order/tvv-view/${item?.cart_register_id}`);
        }}
        justify="start"
        key={index}
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="cursor-pointer py-3 border-b transition duration-300 border-gray-300 hover:bg-gray-100"
      >
        <Col span={2}>
          <CartBlue />
        </Col>
        <Col span={22}>
          <Row className="font-bold">{item?.pof_type_name}</Row>
          <Row>{item?.cart_name}</Row>
          <Row className="text-neutral-80">
            Cập nhật lần cuối: {item?.updated_at || '-'}
          </Row>
        </Col>
        <Divider />
      </Row>
    ));
  };
  return (
    <div style={{ width: '500px', padding: '20px' }}>{renderContent()}</div>
  );
}
